import { gql } from "@apollo/client";

export const GET_MOTIVOS_NO_INGRESO = gql`
query allMotivoNIngreso{
    allMotivoNIngreso {
        idMotivoNIngreso,
        motivoNoIngreso
    }
  }
`;

export const adaptMotivoNIngreso = (motivo) => ({
  id: motivo.idMotivoNIngreso,
  displayName: motivo.motivoNoIngreso
});

export const adaptMotivoNIngresoArray = (motivos) =>
structuredClone(motivos?.allMotivoNIngreso)?.
map((motivo) => adaptMotivoNIngreso(motivo));